import { render, staticRenderFns } from "./MaterialityReports.vue?vue&type=template&id=53cc6e0b&scoped=true"
import script from "./MaterialityReports.vue?vue&type=script&lang=js"
export * from "./MaterialityReports.vue?vue&type=script&lang=js"
import style0 from "./MaterialityReports.vue?vue&type=style&index=0&id=53cc6e0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc6e0b",
  null
  
)

export default component.exports